import React from 'react';
import { Skeleton } from '@mui/material';

const TinyLineSkeleton: React.FC = () => {
  return <Skeleton variant="text" width={300} height={150} />;
};

export default TinyLineSkeleton;
